import React from 'react';
import { translate } from 'react-i18next';

class SidebarAvailableShiftLink extends React.Component {
  constructor(props) {
    super(props);
    this.onInternalClickHandler = this.onInternalClickHandler.bind(this);
  }

  componentDidMount() {
    if (
      !Utils.isNotDefined(this.props.selectedShift)
      && this.props.selectedShift == this.props.shiftID
    ) {
      this.props.onClickHandler({}, this.props.shiftID);
    }
  }

  onInternalClickHandler(e) {
    this.props.onClickHandler(e, this.props.shiftID);
  }

  render() {
    return (
      <li data-shift-id={this.props.shiftID}>
        {this.props.startTime}
        {' – '}
        {this.props.endTime}
        <span
          className="shift-details available-details details-item"
          onClick={e => this.onInternalClickHandler(e)}
          data-shift-replied={this.props.replied}
        >
          {this.props.t('SidebarAvailableShiftLink.details')}
        </span>
      </li>
    );
  }
}

export default translate()(SidebarAvailableShiftLink);
